import { render, staticRenderFns } from "./NbTypographies.vue?vue&type=template&id=31b09908&scoped=true&"
import script from "./NbTypographies.vue?vue&type=script&lang=js&"
export * from "./NbTypographies.vue?vue&type=script&lang=js&"
import style0 from "./NbTypographies.vue?vue&type=style&index=0&id=31b09908&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b09908",
  null
  
)

export default component.exports